import Api from '@/modules/core/api/api.ts';
import { ExternalEndPoint } from '@/modules/common/enums/end-point.ts';
import { BankCbrfAdapter } from '@/modules/core/adapters/bank-cbrf.adapter.ts';

export default class ExternalApi {
  static async getBanksCBRF(signal: AbortSignal) {
    const response = await Api.post(ExternalEndPoint.getBanksCBRF, {}, signal);
    return BankCbrfAdapter.mapList(response);
  }
}
